export const SubscriptionCategoryPageTemplate = {
    slots: ['SlbSubscriptionsPLPSlot'],
};

export const SubscriptionPackagePDPPageTemplate = {
    slots: ['SlbSubscriptionsVariantPdpFeatureSlot']
}